// extracted by mini-css-extract-plugin
module.exports = {"whoops":"Whoops_whoops__1Qzhn","infoWrapper":"Whoops_infoWrapper__LslaY","whoopsText":"Whoops_whoopsText__19glC","messageText":"Whoops_messageText__1u7s8"};